<!--ExperienceTabs: 体验中心-tab切换 2020/08/26 14:40:21 YuAng-->

<template>
  <div class="its-tabs" id="tabHeader">
    <div v-if="tabFixed" class="its-tab-header-block"></div>
    <div class="its-tabs-body" :class="{'its-tab-item-fixed':tabFixed,'its-show-download':showDownload}">
        <experience-tab-item :tabs="tabs" ref="tabItem" @fullScreen="fullScreen"></experience-tab-item>
    </div>
    <template v-for="(tabItem,i) in tabs" >
      <div :key="i" class="its-tab-block" :style="{'height':height}" :id="'tabItem-'+tabItem.item.key"></div>
    </template>
    <tab-menu v-if="tabFixed && false" ref="menu" :tabs="tabs" :father-action="menuAction"></tab-menu>
  </div>
</template>
<script>
import ExperienceTabItem from './ExperienceTabItem'
import TabMenu from './Menu'
export default {
  name:'ExperienceTabs',
  components:{
    ExperienceTabItem,
    TabMenu
  },
  props:{
    tabs:{
      type: Array,
      default:function(){
        return []
      }
    },
    fatherAction:{
      type: Function,
      default: null
    }
  },
  data(){
    return {
      height:'',
      activeTab: 1,
      tabFixed: false,
      offsetTop: 0,
      tabClicked:false,
      showDownload:false,
      distances: [],
      realOffsetTop: 0,
      isFullScreenEvent: false
    }
  },
  mounted () {
    this.offsetTop = document.querySelector('#tabHeader').offsetTop - 1
    window.addEventListener('scroll', this.handleScrollFun)
    this.addlisteners()
    this.height = document.documentElement.clientHeight - 80 +'px'
    this.hiddenFooter()
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0 
    }, 500)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScrollFun)
    this.removeListeners()
  },
  methods:{
    tabClick:function(i){
      this.hiddenFooter()
      this.activeTab = i
      this.$refs.tabItem.setActiveItem(this.activeTab - 1)
      setTimeout(() => {
        this.tabClicked = false
      }, 1);
      this.tabFixed = true
      if(this.distances.length==0){
        for(let i = 1; i <= this.tabs.length; i++){
          let distance = this.$el.querySelector('#tabItem-'+i).offsetTop - 80
          this.distances.push(distance)
        }
      }
      document.documentElement.scrollTop = document.body.scrollTop = this.distances[this.activeTab-1]
      setTimeout(() => {
        this.addlisteners()
      }, 300)
    },
    handleScrollFun: function () {
      setTimeout(() => {
        if(this.tabClicked || this.isFullScreenEvent){
          return
        }
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > this.offsetTop) {
            this.tabFixed = true
        } else {
            this.tabFixed = false
            this.hiddenFooter()
            this.activeTab = 1
            // this.$refs.tabItem.setActiveItem(this.activeTab - 1)
        }
      }, 300);
    },
    handleMouseWheel:function(e){
      if(!this.tabFixed){
        return
      }
      if(e.wheelDelta < 0 || e.detail>0){
        //向下翻滚
        this.realOffsetTop = this.offsetTop - 80
        if(this.activeTab===this.tabs.length){
          this.showFooter()
          return
        }else{
          this.activeTab += 1
        }
      }else{
        //向上翻滚
        this.realOffsetTop = this.offsetTop + 80
        if(this.showDownload&&this.activeTab===this.tabs.length){
          //从底部上滚
        } else if (this.activeTab===1){
          // return
        } else {
          this.activeTab -= 1
        }
      }
      this.removeListeners()
      // this.$refs.menu.activeTab = this.activeTab
      this.tabClick(this.activeTab)
    },
    hiddenFooter:function(){
      this.showDownload = false
      document.getElementById('footers').style.position = 'relative'
    },
    showFooter:function(){
      this.showDownload = true
      document.getElementById('footers').style.position = 'fixed'
    },
    addlisteners:function(){
      window.addEventListener('mousewheel', this.handleMouseWheel)
      window.addEventListener('DOMMouseScroll', this.handleMouseWheel)
    },
    removeListeners:function(){
      window.removeEventListener('mousewheel', this.handleMouseWheel)
      window.removeEventListener('DOMMouseScroll', this.handleMouseWheel)
    },
    menuAction: function(data) {
      console.log(data)
      this.tabClick(data.key)
    },
    fullScreen: function (isFullScreen) {
      console.log(isFullScreen)
      this.isFullScreenEvent = true
      setTimeout(() => {
        this.isFullScreenEvent = false
      }, 1000);
      if(!isFullScreen) {
        this.tabClick(this.activeTab)
      }
    }
  }
}
</script>
<style scoped>
.its-tabs-fixed{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}
.its-tabs-header{
  width: 100%;
  height: 80px;
  box-shadow:0 5px 10px -5px rgba(134,134,134,0.3);
  text-align: center;
  position: relative;
  z-index: 11;
  background: white;
}
.its-tab-fixed{
  position: fixed;
  top: 0;
  z-index: 2001;
}
.its-tab-item-fixed{
  position: fixed;
  top: 80px;
  width: 100%;
  z-index: 2;
  background-color: white;
}
.its-show-download{
  top: -370px !important; /* 20 */
}
.its-tabs::after{
  clear: both;
  content: '';
  display: block;
}
.its-tab{
  width: 300px;
  display: inline-block;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.its-tab .its-main-title{
  color: #404857;
  cursor: pointer;
  font-size: 20px;
  font-weight: 300;
  display: inline-block;
  height: 100%;
}
.its-tab .its-main-title:hover,
.its-tab .its-main-title.active{
  color: #4390ff;
}
.its-tab .its-main-title.active{
  border-bottom: 3px solid #4390ff;
}
.its-tab-header-block{
  height: 80px;
  width: 100%;
}
.its-tab-body-block{
  width: 100%;
  height: calc(100vh - 80px);
}
</style>
